import { FC, ReactElement } from 'react'
import { CirclePlus, CircleCheck } from 'lucide-react'

const SelectButton: FC<{ onSelect: () => void; selected: boolean; disabled?: boolean }> = (
	props
): ReactElement => {
	const { onSelect, selected, disabled } = props

	return (
		<button
			type="button"
			aria-label={selected ? 'Deselect item' : 'Select item'}
			aria-pressed={selected}
			disabled={disabled}
			className="inline-flex size-5 shrink-0 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed"
			onClick={(event) => {
				event.stopPropagation()
				onSelect()
			}}
			onKeyDown={(event) => {
				// Let the button activate without also selecting the surrounding command row.
				if (event.key === 'Enter' || event.key === ' ') event.stopPropagation()
			}}
		>
			{selected ? (
				<CircleCheck className="size-5 stroke-violet-500" />
			) : (
				<CirclePlus className="size-5 stroke-zinc-400" />
			)}
		</button>
	)
}

export default SelectButton
